<template>
  <div class="results3-wrap">
    <main class="screen" role="main">

      <span class="badge">Dein Ergebnis</span>

      <p class="narrative">
        Du hast eine <span class="accent">solide Basis</span>. Du isst regelmässig
        Gemüse, Früchte und trinkst genügend Wasser. Bei
        <span class="accent">pflanzlichen Proteinen</span> und
        <span class="accent">Vollkornprodukten</span> liegt dein grösstes
        Potenzial.
      </p>

      <div class="score-line">
        <span class="score-label">Score</span>
        <span class="score-value">{{ overallScore }}</span>
        <span class="score-max">/ {{ overallMax }}</span>
        <div class="score-bar">
          <div class="score-bar-fill" :style="{ width: scorePct + '%' }"></div>
        </div>
      </div>

      <h2 class="section-heading">Drei Vorschläge für dich</h2>

      <div class="suggestion-list">
        <div
          v-for="(s, i) in topSuggestions"
          :key="i"
          class="suggestion-card"
        >
          <span class="suggestion-number">{{ i + 1 }}</span>
          <div class="suggestion-content">
            <p class="suggestion-headline">{{ s.headline }}</p>
            <p class="suggestion-detail">{{ s.detail }}</p>
          </div>
        </div>
      </div>

      <div class="mini-block">
        <p class="mini-block-title">Deine sieben Lebensmittelgruppen</p>
        <div class="mini-bars">
          <div
            v-for="g in groups"
            :key="g.id"
            class="mini-bar"
          >
            <div class="mini-bar-fill" :style="{ height: g.score + '%' }"></div>
          </div>
        </div>
        <div class="mini-labels">
          <span v-for="g in groups" :key="g.id" class="mini-label">{{ g.emoji }}</span>
        </div>
      </div>

      <button type="button" class="meaning-link" @click="onMeaningClick">
        Was bedeutet das?
      </button>

      <div class="footer">
        <button type="button" class="next-button" @click="goNext">Weiter</button>
      </div>

      <p class="placeholder-note">
        Beispieltexte. Die finalen Formulierungen werden vom Ernährungsteam erstellt.
      </p>

    </main>
  </div>
</template>

<script>
import { overallScore, overallMax, groups, topSuggestions } from '../_data/sampleResults.js';

export default {
  name: 'Results3',
  data() {
    return { overallScore, overallMax, groups, topSuggestions };
  },
  computed: {
    scorePct() {
      return Math.round((this.overallScore / this.overallMax) * 100);
    },
  },
  methods: {
    goNext() {
      this.$router.push('/postsurvey/email');
    },
    onMeaningClick() {
      // Placeholder for "Was bedeutet das?"
    },
  },
};
</script>

<style scoped>
.results3-wrap {
  --color-bg-page: #f5f4ef;
  --color-bg-card: #ffffff;
  --color-bg-muted: #f1efe8;
  --color-text-primary: #2c2c2a;
  --color-text-secondary: #5f5e5a;
  --color-text-tertiary: #888780;
  --color-border: rgba(0, 0, 0, 0.15);
  --color-accent: #534AB7;
  --color-accent-light: #EEEDFE;
  --radius-md: 8px;
  --radius-lg: 12px;
  --font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  --font-serif: Georgia, "Iowan Old Style", serif;

  background: var(--color-bg-page);
  font-family: var(--font-sans);
  color: var(--color-text-primary);
  line-height: 1.5;
  min-height: 100%;
  padding: 1.25rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
}

.results3-wrap *,
.results3-wrap *::before,
.results3-wrap *::after {
  box-sizing: border-box;
}

.screen {
  width: 100%;
  max-width: 420px;
  background: var(--color-bg-card);
  border-radius: var(--radius-lg);
  border: 0.5px solid var(--color-border);
  padding: 2rem 1.5rem;
  min-height: 600px;
}

.badge {
  display: inline-block;
  background: var(--color-accent-light);
  color: var(--color-accent);
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: var(--radius-md);
  margin-bottom: 1.5rem;
  letter-spacing: 0.02em;
}

.narrative {
  font-family: var(--font-serif);
  font-size: 19px;
  line-height: 1.6;
  color: var(--color-text-primary);
  margin: 0 0 1.5rem;
}

.narrative .accent {
  color: var(--color-accent);
  font-weight: 500;
}

.score-line {
  display: flex;
  align-items: baseline;
  gap: 12px;
  padding: 16px 0;
  border-top: 0.5px solid var(--color-border);
  border-bottom: 0.5px solid var(--color-border);
  margin-bottom: 1.5rem;
}

.score-label {
  font-size: 14px;
  color: var(--color-text-secondary);
}

.score-value {
  font-size: 28px;
  font-weight: 500;
  color: var(--color-accent);
  line-height: 1;
}

.score-max {
  font-size: 14px;
  color: var(--color-text-tertiary);
}

.score-bar {
  flex: 1;
  height: 6px;
  background: var(--color-bg-muted);
  border-radius: 3px;
  overflow: hidden;
}

.score-bar-fill {
  height: 100%;
  background: var(--color-accent);
  border-radius: 3px;
}

.section-heading {
  font-size: 14px;
  font-weight: 500;
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin: 0 0 0.75rem;
}

.suggestion-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 1.5rem;
}

.suggestion-card {
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: 14px 16px;
  background: var(--color-bg-card);
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.suggestion-number {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--color-accent);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 500;
}

.suggestion-content {
  flex: 1;
}

.suggestion-headline {
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 4px;
  color: var(--color-text-primary);
}

.suggestion-detail {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin: 0;
  line-height: 1.5;
}

.mini-block {
  background: var(--color-bg-muted);
  border-radius: var(--radius-md);
  padding: 14px 12px 8px;
  margin-bottom: 1.5rem;
}

.mini-block-title {
  font-size: 12px;
  color: var(--color-text-secondary);
  text-align: center;
  margin: 0 0 8px;
}

.mini-bars {
  display: flex;
  gap: 6px;
  align-items: flex-end;
  height: 110px;
  margin-bottom: 8px;
  padding: 0 4px;
}

.mini-bar {
  flex: 1;
  height: 100%;
  background: rgba(0, 0, 0, 0.08);
  border-radius: 3px;
  position: relative;
  min-height: 4px;
}

.mini-bar-fill {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--color-accent);
  border-radius: 3px;
}

.mini-labels {
  display: flex;
  gap: 6px;
  padding: 0 4px;
}

.mini-label {
  flex: 1;
  text-align: center;
  font-size: 16px;
  line-height: 1;
}

.meaning-link {
  font-size: 13px;
  color: var(--color-text-secondary);
  background: transparent;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
  font-family: inherit;
  padding: 0;
  margin: 0 0 1.5rem;
}

.footer {
  margin-top: 1.5rem;
}

.next-button {
  width: 100%;
  padding: 14px;
  background: var(--color-accent);
  color: white;
  border: 0.5px solid var(--color-accent);
  border-radius: var(--radius-md);
  font-size: 15px;
  font-family: inherit;
  cursor: pointer;
}

.next-button:hover { opacity: 0.9; }

.placeholder-note {
  font-size: 11px;
  color: var(--color-text-tertiary);
  text-align: center;
  margin-top: 12px;
  font-style: italic;
}
</style>
